import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateAdapter, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import {
  MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS,
  MatLegacyDialogModule as MatDialogModule,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { S3Service } from '@app/services/s3/s3.service';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { HistoricoProdutoService } from '@app/shared/components/historico-produto-dialog/historico-produto-dialog.service';
import { OnlyNumberDirective } from '@app/shared/directives/only-number.directive';
import { CpfPipe } from '@app/shared/pipes/cpf.pipe';
import { AstutusModalComponent } from '@bower-components/astutus-modal/modal.component';

import { DateAdapterBr } from '@shared/components/datepicker/date-adapter-br';
import { HistoricoProdutoDialogComponent } from '@shared/components/historico-produto-dialog/historico-produto-dialog.component';
import { RemoveDialogComponent } from '@shared/components/remove-dialog/remove-dialog.component';
import { AstutusFloatLabelDirective } from '@shared/directives/astutus-float-label.directive';
import { AutofocusDirective } from '@shared/directives/autofocus.directive';
import { DateMaskDirective } from '@shared/directives/date-mask.directive';
import { NumericoNegativoDirective } from '@shared/directives/numerico-negativo.directive';
import { NumericoDirective } from '@shared/directives/numerico.directive';
import { TelefoneDirective } from '@shared/directives/telefone.directive';
import { TextFormatDirective } from '@shared/directives/textFormat.directive';
import { TrimValueDirective } from '@shared/directives/trim-value.directive';
import { CnpjPipe } from '@shared/pipes/cnpj.pipe';
import { ReuseStrategyObservable } from '@shared/router/reuse-strategy-observable';
import { AgGridRenderer } from '@shared/table/ag-grid/ag-grid-renderer';
import { AgGridModule } from 'ag-grid-angular';
import { CheckboxComponent } from './components/ag-grid/check-box.component';
import { DownloadFilesService } from './components/download-file/download-file.service';
import { DownloadService } from './components/download-file/download.service';
import { RadioButtonService } from './components/radio-button/radio-button-service';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { ProdutoConverterService } from './converters/ProdutoConverter.service';
import { CpfCnpjFormatDirective } from './directives/cpf-cnpj-format.directive';
import { DynamicSizeVirtualScrollDirective } from './directives/dynamic-size-virtual-scroll/dynamic-size-virtual-scroll.directive';
import { OnlyNumberTextDirective } from './directives/only-number-text.directive';
import { ProgressBarComponent } from './directives/progress-bar.component';
import { SelectOnFocusDirective } from './directives/select-on-focus.directive';
import { StepperTouchDirective } from './directives/stepper-touch.directive';
import { TrimDirective } from './directives/trim';
import { AgGridResizeApiDirective } from './table/ag-grid/ag-grid-resize-api.directive';
// https://angular.io/guide/styleguide#shared-feature-module
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTableModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatNativeDateModule,
    AgGridModule,
    DynamicSizeVirtualScrollDirective,
    AgGridResizeApiDirective,
    SelectOnFocusDirective,
    DateMaskDirective,
    TrimValueDirective,
    OnlyNumberDirective,
    NumericoDirective,
    TextFormatDirective,
    TelefoneDirective,
    AstutusFloatLabelDirective,
    CnpjPipe,
    TrimDirective,
    CpfCnpjFormatDirective,
  ],
  declarations: [
    NumericoNegativoDirective,
    AutofocusDirective,
    ProgressBarComponent,
    CpfPipe,
    AstutusModalComponent,
    RemoveDialogComponent,
    HistoricoProdutoDialogComponent,
    CheckboxComponent,
    RadioButtonComponent,
    OnlyNumberTextDirective,
    ConfirmDialogComponent,
    StepperTouchDirective,
  ],
  providers: [
    HistoricoProdutoService,
    RadioButtonService,
    { provide: DateAdapter, useClass: DateAdapterBr },
    ProdutoConverterService,
    S3Service,
    DownloadFilesService,
    DownloadService,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DateMaskDirective,
    NumericoDirective,
    NumericoNegativoDirective,
    TrimValueDirective,
    TrimDirective,
    TextFormatDirective,
    TelefoneDirective,
    AstutusFloatLabelDirective,
    AutofocusDirective,
    ProgressBarComponent,
    CnpjPipe,
    CpfPipe,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTableModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatNativeDateModule,
    RemoveDialogComponent,
    AstutusModalComponent,
    AgGridModule,
    AgGridResizeApiDirective,
    OnlyNumberDirective,
    OnlyNumberTextDirective,
    SelectOnFocusDirective,
    StepperTouchDirective,
    DynamicSizeVirtualScrollDirective,
    CpfCnpjFormatDirective,
  ],
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      providers: [
        ReuseStrategyObservable,
        AgGridRenderer,
        DecimalPipe,
        CurrencyPipe,
        PercentPipe,
        DatePipe,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, direction: 'ltr' } },
      ],
      ngModule: SharedModule,
    };
  }
}
